var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgM(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 51,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.91.6c.577 0 1.057.216 1.44.648.433.384.649.888.649 1.512v46.08c0 .624-.216 1.152-.648 1.584-.432.384-.96.576-1.584.576-.672 0-1.224-.192-1.656-.576a2.155 2.155 0 01-.648-1.584V9.24l-16.92 25.632c-.48.624-1.032.912-1.656.864h-.144c-.576 0-1.104-.288-1.584-.864L5.239 9.096V48.84c0 .624-.216 1.152-.648 1.584-.384.384-.888.576-1.512.576s-1.128-.192-1.512-.576c-.384-.432-.576-.96-.576-1.584V2.76c0-.576.192-1.08.576-1.512C1.999.816 2.527.6 3.15.6c.336 0 .696.096 1.08.288.384.144.672.36.864.648l18.864 28.296L42.967 1.536C43.495.816 44.143.504 44.91.6z",
    fill: "currentColor"
  })));
}
export default SvgM;